export default __webpack_public_path__ + "link-empty.3d4796bf.svg";